// Used as the basis and extended by other Question Type components

<script>
  import logic from '../../composables/QuestionTypes/BaseType'

  export default logic
</script>